<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">User Referrals</h3>
        </v-flex>
        <v-flex xs12 md8 sm10>
          <v-text-field label="Search" v-model="filterBy" prepend-icon="search" :append-icon="filterBy.length > 0 ? 'close' : ''" @click:append="() => (filterBy = '')"></v-text-field>
          <v-card>
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              <date-picker v-model="mydate"></date-picker>
            </v-card-title>
            <v-card-text>
              <referrals-table :referrals="referrals" :serch="filterBy" :loading="loading" :date="mydate"></referrals-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Reports'
  const ReferralsTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "referrals" */ '@/Components/Referral/referrals')

  const DatePicker = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/datepicker')

  export default {
    name: 'Referrals',
    layout,
    props: [
      'referrals',
      'date',
    ],
    components: {
      ReferralsTable,
      DatePicker,
    },
    metaInfo () {
      return {
        title: 'User Referrals',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: '',
        mydate: this.date,
        loading: false,
      }
    },
    methods: {
      fetchData () {
        this.$inertia.get('/referral-codes', { date: this.mydate }, {
          onBefore: () => {
            this.loading = true;
          },
          onFinish: () => {
            this.loading = false;
          },
          preserveScroll: true,
          preserveState: true,
        })
      },
    },
    computed: {},
    watch: {
      'mydate': 'fetchData',
    }
  }
</script>

<style>
   /**/
</style>
